import { OverlayModule } from '@angular/cdk/overlay';
import { CdkPortalOutlet, ComponentPortal, PortalModule, TemplatePortal } from '@angular/cdk/portal';
import { Component, ComponentRef, EmbeddedViewRef, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonDirective } from 'shared/ui-common';

import { DialogCloseDirective } from './dialog-close.directive';
import { DialogConfig } from './dialog-config';
import { IconDirective } from '../icon/icon.directive';

@Component({
  selector: 'common-dialog',
  standalone: true,
  imports: [OverlayModule, PortalModule, DialogCloseDirective, MatIconModule, IconDirective, TranslocoPipe, ButtonDirective],
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  host: {
    class: 'tt-common-dialog',
    '[attr.data-testid]': 'data?.testId',
  },
})
export class DialogComponent {
  @ViewChild(CdkPortalOutlet, { static: true }) public portalOutlet: CdkPortalOutlet;
  public data: Partial<DialogConfig>;

  public attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T> {
    return this.portalOutlet.attachComponentPortal(portal);
  }

  public attachTemplatePortal<C>(portal: TemplatePortal<C>): EmbeddedViewRef<C> {
    return this.portalOutlet.attachTemplatePortal(portal);
  }
}
